import styles from "./TaskTabsToggle.module.css";

export type TaskTabValue = "ongoing" | "completed";

export interface TaskTabsToggleProps {
	value: TaskTabValue;
	onChange: (next: TaskTabValue) => void;
	ongoingLabel: string;
	completedLabel: string;
}

export function TaskTabsToggle({
	value,
	onChange,
	ongoingLabel,
	completedLabel,
}: TaskTabsToggleProps) {
	return (
		<div className={styles.container} role="tablist" aria-label={ongoingLabel}>
			<button
				type="button"
				role="tab"
				aria-selected={value === "ongoing"}
				data-active={value === "ongoing"}
				className={styles.button}
				onClick={() => onChange("ongoing")}
			>
				{ongoingLabel}
			</button>
			<button
				type="button"
				role="tab"
				aria-selected={value === "completed"}
				data-active={value === "completed"}
				className={styles.button}
				onClick={() => onChange("completed")}
			>
				{completedLabel}
			</button>
		</div>
	);
}
